import { WINDOW_KEYS, type WindowKey } from '@meridian/contracts';

import styles from './window-toggle.module.css';

import type { JSX } from 'react';

export interface WindowToggleProps {
  readonly value: WindowKey;
  readonly onChange: (value: WindowKey) => void;
}

export function WindowToggle({ value, onChange }: WindowToggleProps): JSX.Element {
  return (
    <div className={styles['group']} role="group" aria-label="Return window">
      {WINDOW_KEYS.map((key) => (
        <button
          key={key}
          type="button"
          className={styles['btn']}
          aria-pressed={value === key}
          onClick={() => {
            onChange(key);
          }}
        >
          {key}
        </button>
      ))}
    </div>
  );
}
